import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListEventCampaignPayload } from '@app-store/slices/campaigns/eventCampaignList'

interface TaskAction extends Action {
    payload: IListEventCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.group.list

function* listGrouptSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/group`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listGrouptSagaTask)
}

export default listGroupSaga
